import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useTracking from '../../hooks/useTracking';

const stepsByPath = {
  '/rencontre/genre': 'genre',
  '/rencontre/recherche': 'recherche',
  '/rencontre/relation': 'relation',
  '/rencontre/profil': 'profil',
  '/rencontre/inscription': 'inscription',
  '/rencontre/regles': 'regles',
  '/rencontre/photos': 'photos',
  '/rencontre/localisation': 'localisation'
};

const EncounterFunnelTracker = () => {
  const location = useLocation();
  const tracking = useTracking();

  useEffect(() => {
    const step = stepsByPath[location.pathname];
    if (step) tracking.trackFunnelEvent('step_viewed', step);
    // trackFunnelEvent dépend volontairement du chemin courant.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};

export default EncounterFunnelTracker;
